import { useMemo } from 'react';

import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import type { JSONDocNode } from '@atlaskit/editor-json-transformer';
import {
	ProseMirrorContentStatistics,
	type ContentStatistics,
} from '@atlassian/ai-model-io/utils/prosemirror-content-statistics';

export function usePromptStatistics({
	userADFInput,
}: {
	userADFInput: JSONDocNode | undefined;
}): ContentStatistics | undefined {
	return useMemo(() => {
		const jsonTransformer = new JSONTransformer();
		const promptStats = userADFInput
			? new ProseMirrorContentStatistics(jsonTransformer.parse(userADFInput))
			: undefined;

		return promptStats?.collectStatistics();
	}, [userADFInput]);
}
